var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcaseAddService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 36.6667H26.6665C33.3665 36.6667 34.5665 33.9833 34.9165 30.7167L36.1665 17.3833C36.6165 13.3167 35.4499 10 28.3332 10H11.6665C4.54987 10 3.38321 13.3167 3.83321 17.3833L5.08321 30.7167C5.43321 33.9833 6.63321 36.6667 13.3332 36.6667Z",
    stroke: "#525455",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 9.99999V8.66666C13.3335 5.71666 13.3335 3.33333 18.6668 3.33333H21.3335C26.6668 3.33333 26.6668 5.71666 26.6668 8.66666V9.99999",
    stroke: "#525455",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3332 21.6667V23.3333C23.3332 23.35 23.3332 23.35 23.3332 23.3667C23.3332 25.1833 23.3165 26.6667 19.9998 26.6667C16.6998 26.6667 16.6665 25.2 16.6665 23.3833V21.6667C16.6665 20 16.6665 20 18.3332 20H21.6665C23.3332 20 23.3332 20 23.3332 21.6667Z",
    stroke: "#525455",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0835 18.3333C32.2335 21.1333 27.8335 22.8 23.3335 23.3667",
    stroke: "#525455",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3667 18.7825C8.1167 21.3492 12.35 22.8992 16.6667 23.3825",
    stroke: "#525455",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseAddService);
export default __webpack_public_path__ + "static/media/briefcase-add-service.3e2fbae0cedfa29d7f5e9efcd8807bba.svg";
export { ForwardRef as ReactComponent };